export const navigateToLogin = () => {
  localStorage.clear();
  window.location.href = '/login';
};
